const prvs = new Parvus({
	// All elements with this class triggers Parvus
	// selector:
	selector: ".wp-block-image a[href]",

	// All `selector` in this `gallerySelector` are combined as a gallery. Overwrites the `data-group` attribute
	gallerySelector: "main",

	captionsSelector: ".wp-block-image figcaption",

	// Click outside to close Parvus
	docClose: true,

	// Scroll to close Parvus
	scrollClose: false,

	// Swipe up to close Parvus
	swipeClose: true,

	// Accept mouse events like touch events (click and drag to change slides)
	simulateTouch: false,

	// Touch dragging threshold (in px)
	threshold: 100,

	// Focus thumbnail from the last active slide after closing instead focus last active element before opening
	backFocus: true,

	// Specifies how many milliseconds(ms) the transition effects takes to complete
	transitionDuration: 300,

	// Specifies the speed curve of the transition effects
	transitionTimingFunction: "cubic-bezier(0.2, 0, 0.2, 1)",

	// Icons
	lightboxIndicatorIcon:
		'<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>',
	previousButtonIcon:
		'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path stroke="none" d="M0 0h24v24H0z"/><polyline points="15 6 9 12 15 18" /></svg>',
	nextButtonIcon:
		'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path stroke="none" d="M0 0h24v24H0z"/><polyline points="9 6 15 12 9 18" /></svg>',
	closeButtonIcon:
		'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M18 6L6 18M6 6l12 12"/></svg>',

	// Internationalization
	lang: "en",
	i18n: {
		en: {
			lightboxLabel:
				"This is a dialog window which overlays the main content of the page. The modal shows the enlarged image. Pressing the Escape key will close the modal and bring you back to where you were on the page.",
			lightboxLoadingIndicatorLabel: "Image loading",
			previousButtonLabel: "Previous image",
			nextButtonLabel: "Next image",
			closeButtonLabel: "Close dialog window",
		},
	},

	// Regular expression for supported image file types
	fileTypes: /\.(png|jpe?g|webp|avif|svg)(\?.*)?$/i,
});

// bind event listener
prvs.on("open", function () {
	document.documentElement.classList.add("modal-is-open");
});

// unbind event listener
prvs.on("close", function () {
	document.documentElement.classList.remove("modal-is-open");
});
